export default {
  newEmployer: 'New Employer',
};
